module.exports = __webpack_public_path__ + "img/first.63bae7ac.svg";